import { Children, ComponentType } from 'react';

import { resolveComponent } from './resolveComponent';

import { NodeData, ReducedComp, SerializedNode } from '../interfaces';
import { Resolver } from '../interfaces';
const reduceType = (type: ComponentType, resolver: Resolver) => {
    return { resolvedName: resolveComponent(resolver, type) };
};

export const serializeComp = (data: Pick<NodeData, 'type' | 'props'>, resolver: Resolver): ReducedComp => {
    const { type, props } = data;

    const newProps = Object.keys(props).reduce((result: Record<string, unknown>, key) => {
        const prop = props[key];

        if (prop === undefined || prop === null) {
            return result;
        }

        if (key === 'children' && typeof prop !== 'string') {
            result[key] = Children.map(prop, (child) => {
                if (typeof child === 'string') {
                    return child;
                }
                return serializeComp(child as NodeData, resolver);
            });
        } else if ((prop as NodeData).type) {
            result[key] = serializeComp(prop as NodeData, resolver);
        } else if (['account', 'designSettings'].includes(key)) {
            // skip serialize
        } else {
            result[key] = prop;
        }
        return result;
    }, {});

    return {
        type: reduceType(type, resolver),
        props: newProps,
    };
};

export const serializeNode = (data: Omit<NodeData, 'event'>, resolver: Resolver): SerializedNode => {
    // un-expose name field
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { type, props, name, ...nodeData } = data;

    const reducedComp = serializeComp({ type, props }, resolver);

    return {
        ...reducedComp,
        ...nodeData,
    };
};
